import type { Action } from 'redux'
import * as types from '../types/refresh-jwt-types'

export interface RefreshJwtState {
  token: string | null
  load: boolean
  error: string
  success: boolean
}

export const InitialStateRefreshJwt: RefreshJwtState = {
  token: null,
  load: false,
  error: '',
  success: false,
}

export const refreshJwtReducer = (
  state = InitialStateRefreshJwt,
  action: Action & { payload?: any },
): RefreshJwtState => {
  const newState = { ...state }
  
  switch (action.type) {
    case types.REFRESH_JWT_REQUEST:
      newState.load = true
      newState.error = ''
      newState.success = false
      return newState

    case types.REFRESH_JWT_SUCCESS:
      newState.load = false
      newState.error = ''
      newState.token = action.payload.token
      newState.success = true
      return newState

    case types.REFRESH_JWT_ERROR:
      newState.load = false
      newState.error = action.payload
      newState.success = false
      return newState

    case types.REFRESH_JWT_RESET:
      return InitialStateRefreshJwt

    default:
      return state
  }
}
